<template>
    <div>
        <v-row class="mt-1">
            <v-col cols="12" sm="6" md="6">
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="editData.buyer_credentials" label="Buyer Credentials"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="editData.buyer_designations" label="Buyer Designations"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-textarea
                            v-model="editData.buyer_organizations"
                            :label="insuranceBasedListings.includes(editData.listing_type) ? 'Associations' : 'Buyer Organizations'"
                            auto-grow
                            rows="3"
                            hint="Separate mutliple lines with a semi-colon"
                            persistent-hint>
                        </v-textarea>
                    </v-col>
                </v-row>
            </v-col>
             <v-col cols="12" sm="6" md="6">
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="editData.buyer_location" label="Buyer Location"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-textarea
                            v-model="editData.buyer_other"
                            label="Other Buyer Notes"
                            auto-grow
                            rows="6"
                            hint="Separate mutliple lines with a semi-colon"
                            persistent-hint>
                        </v-textarea>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>


<script>
    export default {
        name: 'BuyerRequirements',
        props: [
            'editData',
            'insuranceBasedListings'
        ],
    }
</script>


// WEBPACK FOOTER //
// src/components/prospectus-sections/BuyerRequirements.vue